/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It depends on the intensity — 5 minutes is on the longer side for standard interval rest (which is often 30 seconds to 2 minutes) but is reasonable after an all-out max-effort set or between full circuits rather than individual exercises.`)
};

const es_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende de la intensidad — 5 minutos está en el extremo más largo para el descanso estándar entre intervalos (que suele ser de 30 segundos a 2 minutos), pero es razonable después de una serie de esfuerzo máximo total o entre circuitos completos, más que entre ejercicios individuales.`)
};

const de_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hängt von der Intensität ab — 5 Minuten liegen am oberen Ende üblicher Intervallpausen (oft 30 Sekunden bis 2 Minuten), sind aber sinnvoll nach einem maximal intensiven Satz oder zwischen ganzen Zirkeln statt einzelnen Übungen.`)
};

const nl_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat hangt af van de intensiteit — 5 minuten zit aan de lange kant voor standaard intervalrust (die vaak 30 seconden tot 2 minuten is), maar is redelijk na een set met maximale inspanning of tussen volledige circuits in plaats van individuele oefeningen.`)
};

const fr_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela dépend de l’intensité — 5 minutes, c’est plutôt long pour un repos d’intervalle standard (souvent de 30 secondes à 2 minutes), mais c’est raisonnable après une série à effort maximal ou entre des circuits complets plutôt qu’entre des exercices individuels.`)
};

const it_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dipende dall'intensità — 5 minuti sono sul lato lungo per un riposo a intervalli standard (che è spesso di 30 secondi-2 minuti), ma sono ragionevoli dopo una serie a sforzo massimo o tra circuiti completi piuttosto che tra singoli esercizi.`)
};

const pt_br2_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende da intensidade — 5 minutos está no limite mais longo para o descanso padrão entre intervalos (geralmente de 30 segundos a 2 minutos), mas é razoável depois de uma série de esforço máximo ou entre circuitos completos, em vez de exercícios individuais.`)
};

const pt_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende da intensidade — 5 minutos está no limite superior para o descanso padrão entre intervalos (frequentemente 30 segundos a 2 minutos), mas é razoável depois de uma série de esforço máximo ou entre circuitos completos, em vez de exercícios individuais.`)
};

const ja_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強度によって異なります。5分は標準的なインターバル休憩（多くは30秒〜2分）としてはやや長めですが、全力を尽くしたセットの後や、個別のエクササイズではなく完全なサーキットの間の休憩としては妥当な長さです。`)
};

const zh_timer_u5m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这取决于训练强度 — 对于标准的间歇休息（通常为30秒到2分钟），5分钟偏长，但如果是在一组全力冲刺之后，或是在整轮循环训练之间（而非单个动作之间）休息5分钟是合理的。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u5m_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u5m_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u5m_faq3_a", locale)
	if (locale === "en") return en_timer_u5m_faq3_a(inputs)
	if (locale === "es") return es_timer_u5m_faq3_a(inputs)
	if (locale === "de") return de_timer_u5m_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u5m_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u5m_faq3_a(inputs)
	if (locale === "it") return it_timer_u5m_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u5m_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u5m_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u5m_faq3_a(inputs)
	return zh_timer_u5m_faq3_a(inputs)
};